import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Request } from 'src/app/core/clientHttp/request';
import { HttpService } from 'src/app/core/clientHttp/http.service';
import { ClientLoaderService } from 'src/app/shared/components/client-loader/client-loader.service';
import { ApplymentModel } from './applyment.model';
import { ClientMainBarService } from 'src/app/layout/client/client-main-bar/client-main-bar.service';
import { SuccessCheckLogin } from 'src/app/layout/client/client-main-bar/interface.client-main-bar';
import { TrackingService } from '@modules/client/services/tracking.service';
import { environment } from '@env';
import { AddScriptsService } from '@app/services/applyment/add-scripts/add-scripts.service';
import { VlibrasService } from '@app/services/applyment/vlibras/vilibras.service';

@Injectable({
  providedIn: 'root'
})
export class GetApplymentSettingsService extends Request  {

  constructor(
    private http: HttpService,
    private loaderService: ClientLoaderService,
    private applymentModel: ApplymentModel,
    private titleService: Title,
    private trackingService: TrackingService,
    public clientMainBarService: ClientMainBarService,
    public addScriptsService: AddScriptsService,
    public vlibrasService: VlibrasService,
    private router: Router
  ) {
    super();
  }

  private param = '';
  private response: any = null;
  private token: any = null;
  private domain: any = null;
  private domainParams: any = null;

  private accepted_cookies = false;

  resolve(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot:RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.url = 'applyment/settings/';

    if(routerStateSnapshot.url.split('/').includes('inscricao')) {
      this.clearSessionData();
    }
    
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');
    }

    this.checkLogin();
    const domainOrigin = window.location.origin.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    if (!this.domain) {
      this.domainParams = this.buildUriParams(activatedRouteSnapshot.params)
      this.domain = `${domainOrigin}/${this.domainParams}`;
    }

    this.data = {
      domain: this.domain,
      token: this.token
    };

    return this.http.post(this)
      .then((data) => {
        this.response
      });
  }
 
  private clearSessionData() {
    Object.keys(localStorage).filter(this.isSessionKeyData).forEach(item => delete localStorage[item])
  }

  private isSessionKeyData(key: string): boolean {
    return key.includes('_tracking_') || key === 'token';
  }

  getApplymentModel() {
    return this.applymentModel;
  }

  checkLogin() {
    this.clientMainBarService.checkLogin().subscribe(
      (success: SuccessCheckLogin) => {
        if (success.success) {
          this.applymentModel.setLogged(true);
          this.applymentModel.setPersonName(success.data.person_name);
        } else {
          this.applymentModel.setLogged(false);
        };
      },
      error => {
        console.error('Error: ', error)
      }
    )
  }

  buildUriParams(params) {
    let response = '';
    response += params.uri1 ? '/' + params.uri1 : '';
    response += params.uri2 ? '/' + params.uri2 : '';
    response += params.uri3 ? '/' + params.uri3 : '';
    response += params.uri4 ? '/' + params.uri4 : '';
    response += params.uri5 ? '/' + params.uri5 : '';
    response += params.uri6 ? '/' + params.uri6 : '';
    response += params.uri7 ? '/' + params.uri7 : '';
    response += params.uri8 ? '/' + params.uri8 : '';
    response += params.uri9 ? '/' + params.uri9 : '';
    response += params.uri10 ? '/' + params.uri10 : '';
    response += params.uri ? '/' + params.uri : '';
    return response.indexOf('/') === 0 ? response.slice(1) : response;
  }

  successAction(data) {
    this.response = data;
    const portal_settings = data.data;
    if (data.data && data.success) {
      this.loaderService.setColor(portal_settings.institutional_color);
      this.titleService.setTitle(portal_settings.name);
      localStorage.setItem('token', portal_settings.token);
      portal_settings.domain = this.domain;
      portal_settings.domainParams = this.domainParams;
      this.applymentModel.setSettings(portal_settings);
      localStorage.setItem('crm_domain_' + portal_settings.token , portal_settings.crm_domain);
      this.trackingService.loadTrackingScript();
      this.addScriptsService.addScripts(portal_settings);
      if (portal_settings.gtag_code) {
        this.addScriptsService.injectGtagDefaultScript(portal_settings.gtag_code);
      }
      if (portal_settings.enable_Vlibras) {
        this.vlibrasService.showVlibras();
      }
      if(portal_settings?.remove_session) {
        this.applymentModel.setLogged(this.clientMainBarService.clearSession());
      }
    } else {
      if(this.domain == environment.defaultDomain){
        this.applymentModel.shouldStopRedirectFromRootUrl = true;
      }else{
        this.router.navigate(['pagina-nao-encontrada']);
      }
      this.applymentModel.setSettings(null);
    }
  }


  errorAction(error) {

  }
}
